/**
 * Copyright © Veeam Software Group GmbH.
 */

import { SizeUnit } from '@veeam-vspc/models/web-controllers';

import { core } from 'core/core-module';
import { transformBaseChartData } from 'views/pages/TrendsPage/helpers';

import type { BaseDataResponse } from 'core/services/transport/interfaces/base-data-response';
import type { LineChartData, TrendData } from '../../../../../interfaces';

const names = [
    { label: 'Size', type: SizeUnit.Byte },
];

export class ConsumedStorageService {
    static fetchData({ formatDimension = true, reportingPeriodInfo }): Promise<LineChartData> {
        return core.transportService
            .request('Trends/CloudStorageConsumed', { ...reportingPeriodInfo })
            .then((resp: BaseDataResponse<TrendData>) => transformBaseChartData(resp.data.trends, reportingPeriodInfo, names, formatDimension));
    }
}
